'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateToMarkdown = require('./stateToMarkdown');

Object.defineProperty(exports, 'stateToMarkdown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateToMarkdown).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-export-markdown/lib/main.js
// module id = 1082
// module chunks = 1